import sharedRoutePaths from "@/shared/router/routePaths";

export default {
  questionnairePersonal: "/questionnaire-personal/:questionType?",
  ...sharedRoutePaths,
};
